var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    viewBox: "0 0 200 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.55 3.49999L191.55 46.5L91.0526 46.5L8.44975 46.5L51.4498 3.5L148.55 3.49999Z",
    fill: "url(#paint0_linear_22_162)",
    stroke: "black",
    strokeWidth: 7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_162",
    x1: 0,
    y1: 50,
    x2: 6.35178e-7,
    y2: -0.0000119209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001C31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#002846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#002846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallTimer);
export default __webpack_public_path__ + "static/media/SmallTimer.d6a5a1436f3939598c4f56ce6f13afd4.svg";
export { ForwardRef as ReactComponent };